import React from 'react';
import UIErrorView from "./views/_commons/Error/UIErrorView";

export default class MyErrorBoundary extends React.Component {
    state = {
        error: null,
        errorInfo: null
    };

    // static getDerivedStateFromError(error) {
    //     return {error: error};
    // };

    componentDidCatch(error, errorInfo) {
        // A custom error logging function
        // (errorInfo);

        this.setState({
            error: error,
            errorInfo: errorInfo
        })
    };

    render() {
        return this.state.error ? <UIErrorView error={this.state.error} errorInfo={this.state.errorInfo}/> : this.props.children;
    }
}